// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__Vk8GB","icon":"SortAdornment_icon__evLEX","up":"SortAdornment_up__2qSB9","down":"SortAdornment_down__3M0c0","active":"SortAdornment_active__KbD1H"};